export enum RoleEnum {
  CLIENT = 'CLIENT',
  FABRICATION_IMPRESSION = 'FABRICATION_IMPRESSION',
  FABRICATION_FRAISAGE = 'FABRICATION_FRAISAGE',
  LOGISTIC_COMMANDE = 'LOGISTIC_COMMANDE',
  LOGISTIC_RECOUVREMENT = 'LOGISTIC_RECOUVREMENT',
  LOGISTIC_THERMOFORMAGE = 'LOGISTIC_THERMOFORMAGE',
  LOGISTIC_FRAISAGE = 'LOGISTIC_FRAISAGE',
  LOGISTIC_FABRICATION = "LOGISTIC_FABRICATION",
  GESTION_UTILISATEURS = 'GESTION_UTILISATEURS',
  GESTION_DISTRIBUTEUR = 'GESTION_DISTRIBUTEUR',
  GESTION_FABRICANT = 'GESTION_FABRICANT',
  GESTION_ACTIVITE_SOCIETE = 'GESTION_ACTIVITE_SOCIETE',
  GESTION_PREPARATEUR = "GESTION_PREPARATEUR",
  GESTION_MEMBRE = "GESTION_MEMBRE",
  COMMERCIAL = 'COMMERCIAL',
  GESTION_COMMERCIALE = 'GESTION_COMMERCIALE',
  SUPPORT = 'SUPPORT'
}
